import { ThemeOptions } from '@mui/material';

import { tokens } from '../../../theme/generated/tokens';
import { globalClassNames } from '../../../utils/classNames';

export const formHelperTextTheme: ThemeOptions['components'] = {
  MuiFormHelperText: {
    styleOverrides: {
      root: {
        position: 'relative',
        fontSize: '12px',
        lineHeight: '18px',
        marginTop: 0,
        marginLeft: 0,
        marginRight: 0,
        color: tokens.theme.fg.structural.secondary,
        [`&.${globalClassNames.disabled}`]: {
          color: tokens.theme.disabled.fg,
        },
        [`&.${globalClassNames.error}`]: {
          color: tokens.theme.fg.status.error,
        },
      },
      sizeSmall: {
        fontSize: '10px',
        lineHeight: '16px',
      },
      text: {
        marginTop: '4px',
      },
      textAbsolute: {
        marginTop: 0,
        top: 4,
        position: 'absolute',
      },
    },
  },
};
